var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaSLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 30,
    viewBox: "0 0 76 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3842_4887)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fill-dark-element",
    d: "M27.2323 20.297H23.9531V0.572754H27.2323V20.297ZM27.2323 10.4349L30.117 0.572754H33.5194L30.5361 10.4349L33.5194 20.297H30.117L27.2323 10.4349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-dark-element",
    d: "M23.2006 5.89779V8.58522H19.9215V6.07038C19.9215 4.19657 19.6996 3.60484 18.6887 3.60484C17.6778 3.60484 17.4559 4.19657 17.4559 6.07038V14.7984C17.4559 16.6722 17.6778 17.2639 18.6887 17.2639C19.6996 17.2639 19.9215 16.6722 19.9215 14.7984V12.2835H23.2006V14.971C23.2006 18.9405 21.6227 20.5431 18.6887 20.5431C15.7547 20.5431 14.1768 18.9405 14.1768 14.971V5.89779C14.1768 1.92828 15.7547 0.325684 18.6887 0.325684C21.6227 0.325684 23.2006 1.92828 23.2006 5.89779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-dark-element",
    d: "M13.4364 20.297H10.1572V0.572754H13.4364V20.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-dark-element",
    d: "M0.333008 0.572754H3.83407C8.17342 0.572754 9.40619 2.05207 9.40619 6.02158V8.19125C9.40619 12.1115 8.17342 13.6401 3.85873 13.6401H3.61217V20.297H0.333008V0.572754ZM3.85873 3.85191H3.61217V10.3609H3.85873C5.65857 10.3609 6.12702 9.96644 6.12702 8.19125V6.02158C6.12702 4.2464 5.65857 3.85191 3.85873 3.85191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-dark-element",
    d: "M42.5258 16.7237H40.4346L40.2144 14.4595H38.6893L38.4691 16.7237H36.3779L38.0132 4.14502H40.8905L42.5258 16.7237ZM39.4597 6.4249L38.8937 12.3526H40.0257L39.4597 6.4249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-dark-element",
    d: "M69.0049 0.572754H75.7851V3.85191H72.284V8.78298H75.7851V12.0868H72.284V17.0179H75.7851V20.297H69.0049V0.572754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-dark-element",
    d: "M59.1807 0.572754H62.6324C66.7745 0.572754 68.2538 1.83018 68.2538 5.89831V14.9715C68.2538 18.9903 66.7745 20.297 62.6324 20.297H59.1807V0.572754ZM62.6571 3.85191H62.4598V17.0179H62.6571C64.3829 17.0179 64.9747 16.722 64.9747 14.9715V5.89831C64.9747 4.14778 64.3829 3.85191 62.6571 3.85191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-dark-element",
    d: "M58.4403 20.297H55.1611V0.572754H58.4403V20.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-dark-element",
    d: "M50.8336 8.63453C52.9047 10.2125 54.4086 11.5685 54.4086 15.2422C54.4086 18.6446 53.1512 20.5431 50.02 20.5431C46.8148 20.5431 45.3848 19.0637 45.3848 13.4916H48.6639C48.6639 16.6722 49.0831 17.2639 50.02 17.2639C50.8829 17.2639 51.1295 16.7215 51.1295 15.2422C51.1295 13.5903 50.735 12.9246 49.0338 11.5439C47.2586 10.1385 45.4341 8.88109 45.4341 5.33072C45.4341 2.19949 46.7408 0.325684 49.7734 0.325684C52.7814 0.325684 54.2114 2.19949 54.2114 6.3909H50.9076C50.9076 4.12261 50.4884 3.60484 49.7734 3.60484C49.0338 3.60484 48.7132 4.12261 48.7132 5.33072C48.7132 6.88401 49.4282 7.5497 50.8336 8.63453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5189 24.8474H3.75352V23.1523L0.333008 26.4112L3.75352 29.6741V27.9784H33.5189V24.8474ZM45.3854 27.9784H72.3646V29.6741L75.7851 26.4112L72.3646 23.1523V24.8474H45.3854V27.9784Z",
    fill: "#FFC600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3828 27.9803H72.3652V29.676L75.7859 26.4132L72.3652 23.1543V24.8494H45.3828V27.9803Z",
    fill: "#FFC600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3842_4887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75.452,
    height: 30,
    fill: "white",
    transform: "translate(0.333008)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaSLogo);
export default __webpack_public_path__ + "static/media/PaSLogo.3fbb63e7.svg";
export { ForwardRef as ReactComponent };